import { useMemo } from "react";
import type { MapBoxFilterParams } from "@/react/components/shared/Filter/FilterTypes/MapboxInputFilter";
import { MapboxInputFilter } from "@/react/components/shared/Filter/FilterTypes/MapboxInputFilter";
import type { BaseFilter } from "@/react/components/shared/MemberFilters/types";
import { Filter } from "@circle-react-shared/FilterV3";
import { FilterChip } from "../../shared/FilterV3/FilterChipV2";
import { useFilterProvider } from "../FilterProvider";
import type { LocationFilterConfiguration } from "../types";
import { renderGeoLocationFilterValue } from "../../shared/MemberFilters/SharedFilters/GeoLocationFilter";

interface LocationFilterInputProps {
  configuration: LocationFilterConfiguration;
}

export const LocationFilterInput = ({
  configuration,
}: LocationFilterInputProps) => {
  const { setFilter, filterParamForKey, clearFilterByKey } =
    useFilterProvider();

  const param = useMemo((): MapBoxFilterParams => {
    const existingFilter = filterParamForKey(configuration.key) as
      | MapBoxFilterParams
      | undefined;
    return {
      id: configuration.key,
      key: configuration.key,
      value: existingFilter?.value,
    };
  }, [filterParamForKey, configuration.key]);

  const handleApply = (value: BaseFilter | null) => {
    if (value === null) {
      clearFilterByKey(configuration.key);
    } else {
      setFilter(configuration.key, {
        ...value,
        search_key: configuration.search_key,
      });
    }
  };

  return (
    <Filter onApply={handleApply}>
      <FilterChip
        renderSelectedValue={() => renderGeoLocationFilterValue(param)}
      >
        {configuration.label}
      </FilterChip>
      <Filter.Popover title={configuration.label} placement="bottom">
        <MapboxInputFilter name={configuration.key} param={param} />
      </Filter.Popover>
    </Filter>
  );
};
